export const FacilityNamesIcon = ({
  color = "#475569",
}: {
  color?: string;
}) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12.5V4.98438L4.375 3.125V4.375L7.5 3.125V5H12.5V12.5H0ZM1.25 11.25H11.25V6.25H6.25V4.96875L3.125 6.21875V5L1.25 5.82812V11.25ZM5.625 10H6.875V7.5H5.625V10ZM3.125 10H4.375V7.5H3.125V10ZM8.125 10H9.375V7.5H8.125V10ZM12.5 5H9.375L10 0H11.875L12.5 5Z"
        fill={color}
      />
    </svg>
  );
};
